module.exports = __webpack_public_path__ + "static/media/album-collection.54db058a.svg";